<template>
  <v-col cols="12" class="pa-0 pl-5 pr-5">
    <v-sheet rounded="lg">
      <v-container fluid>
        <h1>Seleção do produto desejado</h1>
        <paragrafo
          >Clique na imagem do produto ou em “Saber mais” (no caso da imagem
          destaque), na página inicial, e assim será possível visualizar a tela
          abaixo e selecionar a data e quantidade de ingressos.</paragrafo
        >
        <imagem :src="image_6" />
        <paragrafo>Seleção de dias e quantidades, veja abaixo:</paragrafo>
        <imagem :src="image_7" />
        <paragrafo
          >Após selecionar as opções, clique em “Adicionar ao carrinho” para dar
          segmento ao fluxo de compra.</paragrafo
        >
        <imagem :src="image_8" />
        <paragrafo
          >Automaticamente será redirecionado ao carrinho. Nela há três
          opções:</paragrafo
        >
        <li>Excluir a reserva do item (clicando na lixeira);</li>
        <li>
          Adicionar outro item a compra, clicando em algum outro produto que
          aparece abaixo ou voltando a página inicial e adicionando outro
          produto ao carrinho;
        </li>
        <li>Finalizar Pedido, será redirecionado as formas de pagamento.</li>
        <imagem :src="image_9" />
        <paragrafo
          >Após o pagamento ser finalizado os itens ficarão disponíveis para
          download, impressão ou compartilhamento.</paragrafo
        >
        <paragrafo
          >As compras realizadas podem ser canceladas clicando na opção
          Cancelar.</paragrafo
        >
      </v-container>
    </v-sheet>
  </v-col>
</template>
<script>
export default {
  name: "name",
  components: {
    paragrafo: () => import("@/docs/components/infos/paragrafo.vue"),
    imagem: () => import("@/docs/components/infos/imagem.vue"),
    // negrito: () => import("@/docs/components/infos/negrito.vue"),
  },
  data() {
    return {
      image_6: "/elevenstore/store/6.png",
      image_7: "/elevenstore/store/7.png",
      image_8: "/elevenstore/store/8.png",
      image_9: "/elevenstore/store/9.png",
    };
  },
};
</script>
